import { Block, Inline, helpers } from "@contentful/rich-text-types";
import { dashify } from "utils/string/dashify";

const H2WithAnchor = (node: Block | Inline) => {
  const [firstChild] = node.content;
  if (!firstChild || !helpers.isText(firstChild)) {
    return null;
  }
  const textContent = firstChild.value;
  return <h2 id={dashify(textContent)}>{textContent}</h2>;
};

const H3WithAnchor = (node: Block | Inline) => {
  const [firstChild] = node.content;
  if (!firstChild || !helpers.isText(firstChild)) {
    return null;
  }
  const textContent = firstChild.value;
  return <h3 id={dashify(textContent)}>{textContent}</h3>;
};

export const headingAnchorRenderer = {
  H2WithAnchor,
  H3WithAnchor,
};
